import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-membership-plans',
  templateUrl: './membership-plans.component.html',
  styleUrls: ['./membership-plans.component.css']
})
export class MembershipPlansComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
